// ==============================================
// DK Bundel — "alles of niets" guard
// Een bundel (dk-bundle-picker) voegt zijn producten +
// een gratis cadeau samen toe, elk met een onzichtbare
// property (_dk_bundle_*). Zodra je één van de vereiste
// bundel-producten uit de winkelwagen haalt, is de héle
// bundel niet meer compleet — dit script haalt dan
// automatisch ook de overige bundel-producten én het
// gratis cadeau weg (in plaats van alleen het cadeau).
// Werkt sitewide: luistert naar alle
// /cart/add|change|update|clear-aanroepen, ongeacht welk
// script (cart.js, cart-drawer.js, de bundle-picker zelf)
// die deed.
// ==============================================
(function () {
  'use strict';
  if (window.__DK_BUNDLE_GIFT_GUARD__) return;
  window.__DK_BUNDLE_GIFT_GUARD__ = true;

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function removeLine(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  var checking = false;

  function checkAndCleanBundles() {
    if (checking) return;
    checking = true;

    fetchCart()
      .then(function (cart) {
        var items = cart.items || [];

        // Per bundle-key: welke slots (bundel-producten) zitten er nog
        // in de winkelwagen, en welke line-item keys horen daarbij.
        var presentSlots = {};
        var bundleLineKeys = {};
        var totalByKey = {};

        items.forEach(function (item) {
          var props = item.properties || {};
          var bundleKey = props._dk_bundle_key;
          var slot = props._dk_bundle_slot;
          if (!bundleKey || !slot) return;

          if (!presentSlots[bundleKey]) presentSlots[bundleKey] = {};
          presentSlots[bundleKey][slot] = true;

          if (!bundleLineKeys[bundleKey]) bundleLineKeys[bundleKey] = [];
          bundleLineKeys[bundleKey].push(item.key);

          if (props._dk_bundle_total) totalByKey[bundleKey] = Number(props._dk_bundle_total);
        });

        var removals = [];
        var handledKeys = {};

        items.forEach(function (item) {
          var props = item.properties || {};
          var giftKey = props._dk_bundle_gift;
          var requiresRaw = props._dk_bundle_requires;
          if (!giftKey || !requiresRaw) return;

          var requires = [];
          try {
            requires = JSON.parse(requiresRaw);
          } catch (e) {
            requires = [];
          }

          var present = presentSlots[giftKey] || {};
          var total = totalByKey[giftKey] != null ? totalByKey[giftKey] : requires.length;

          var complete =
            requires.length > 0 &&
            requires.every(function (slot) {
              return present[slot];
            }) &&
            Object.keys(present).length >= total;

          if (complete) return;

          // Bundel incompleet: cadeau weg, én de eventueel nog
          // overgebleven bundel-producten van dezelfde bundel weg.
          removals.push(item.key);
          if (!handledKeys[giftKey]) {
            handledKeys[giftKey] = true;
            (bundleLineKeys[giftKey] || []).forEach(function (key) {
              removals.push(key);
            });
          }
        });

        // de-dupe
        removals = removals.filter(function (key, idx) {
          return removals.indexOf(key) === idx;
        });

        if (!removals.length) {
          checking = false;
          return;
        }

        window.__DK_BUNDLE_GIFT_GUARD_INTERNAL__ = true;

        var chain = Promise.resolve();
        removals.forEach(function (key) {
          chain = chain.then(function () {
            return removeLine(key);
          });
        });

        chain
          .then(function () {
            var drawer = document.querySelector('cart-drawer.cart-drawer');
            if (drawer && typeof drawer.refresh === 'function') {
              drawer.refresh({ open: false });
            } else if (window.location.pathname.indexOf('/cart') === 0) {
              // Op de losse winkelwagenpagina (geen drawer-component):
              // gewoon herladen zodat de verwijderde regels verdwijnen.
              window.location.reload();
            }
          })
          .catch(function () {})
          .finally(function () {
            window.__DK_BUNDLE_GIFT_GUARD_INTERNAL__ = false;
            checking = false;
          });
      })
      .catch(function () {
        checking = false;
      });
  }

  function shouldWatch(url) {
    if (!url) return false;
    return (
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1 ||
      url.indexOf('/cart/clear') !== -1
    );
  }

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
    var result = origFetch.apply(this, arguments);

    result
      .then(function (res) {
        if (window.__DK_BUNDLE_GIFT_GUARD_INTERNAL__) return;
        if (res && res.ok && shouldWatch(url)) {
          setTimeout(checkAndCleanBundles, 150);
        }
      })
      .catch(function () {});

    return result;
  };

  // Ook meteen checken bij het laden van de pagina (bv. de winkelwagen-
  // pagina zelf openen nadat er eerder al iets verwijderd is).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndCleanBundles);
  } else {
    checkAndCleanBundles();
  }
})();
